// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_EGa","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_pZH StatelessWorkCardsUpsellModal-styles-cls1_EGa"};